<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>
     
     <div class="link_left"><a href="#" style="color: #0D78BF" (click)="scrollDown()" translate>{{'ESR_main.noRESPLink'}}</a></div>
     
     <h1 class="page-title" translate>{{'ESR_main.page_title'}}</h1>
     
     <div html='ESR_main.startSaving'></div>
     
     <div class="left-bar">
          <div class="content" html='ESR_main.statBox1'></div>
     </div>
     <accordion label="ESR_main.accBond" outer-class="display-margin">
           <span translate='ESR_main.expBond_1'></span>    
           <a-link link-url="ESR_main.bondLinkURL" 
                        alt-text="ESR_main.bondLink_alt" 
                        label='ESR_main.bondLink'></a-link>
           <span translate='ESR_main.expBond_2'></span>
     </accordion>

     <accordion label="ESR_main.accGrant" outer-class="display-margin">
           <span translate='ESR_main.expGrant_1'></span>    
           <a-link link-url="ESR_main.grantLinkURL" 
                        alt-text="ESR_main.grantLink_alt" 
                        label='ESR_main.grantLink'></a-link>
           <span translate='ESR_main.expGrant_2'></span>
     </accordion>

     
     <ng-radio [item-list]="data.certifyingParents" id="certifyingParentsRadio"
               [(ng-model)] ="data.CESP.contactParent" 
               [(ng-error)]="error_noParent" vertical>
            <h2 id="selParent" html='ESR_main.contactWho'></h2>
     </ng-radio>
     
     <ng-select [item-list]="items.categoryList" outer-class="top-1" id="categorySelect"
                  [(ng-model)]="data.CESP.category" 
                  placeholder="{{'ESR_main.dropdown.select_category' | translate }}"
                  (change)="categoryChanged()" 
                  (blur)="validate('category')"  
                  [(ng-error)]="error_category"
                  size="18">
            <h2 id="category" html='ESR_main.selCategory'></h2>
      </ng-select>

     <div>{{categoryDesc}}</div>
     <div class="div-prom1">
     <accordion label="ESR_main.accWhatPromoter" outer-class="display-margin">
           <div translate='ESR_main.expWhatPromoter'></div>
     </accordion>
      </div>
     <ng-select   [item-list]="promoterList" [(ng-model)]="data.CESP.promoter" id="promoterSelect"
                  placeholder="{{'ESR_main.dropdown.select_resp_promoter' | translate }}"
                  (blur)="validate('promoter')"  
                  [(ng-error)]="error_promoter" size="18">
            <h2 id="promoter" html='ESR_main.selPromoterToHear'></h2>
     </ng-select>
     <div class="div-prom2">          
     <accordion label="ESR_main.accDontSee" outer-class="display-margin">
           <span translate='ESR_main.expDontSee_1'></span>    
           <a-link link-url="ESR_main.promoLinkURL" 
                        alt-text="ESR_main.promoLink_alt" 
                        label='ESR_main.promoLink'></a-link>
           <span translate='ESR_main.expDontSee_2'></span>
     </accordion>
      </div>   


      <!-- Disclaimer-->
      <div class="title_margin">
            <h2 id="disclaimer" html='ESR_main.disclaimer.header'></h2>
            
            <ng-checkbox [(ng-model)]="data.CESP.chk_disclaimer" id="disclaimerCheckbox" (click)="showDisclaimer($event)"
                         [title]="'ESR_main.discStatementCB_alt' | translate" [(ng-error)]="error_disclaimer"
                              (focusout)="validate('disclaimer')"  >
                  <span translate='ESR_main.disclaimer.text1'></span>    
                  <a [title]="'ESR_main.disclaimer.link_alt' | translate" (click)="showDisclaimer($event)" translate>
                        {{'ESR_main.disclaimer.link'}}</a>
                  <span translate='ESR_main.disclaimer.text2'></span>
            </ng-checkbox>
       </div>

      <div class="title_margin">
            <h2 id="consent" html='ESR_main.consent_statement.header'></h2>
            
            <ng-checkbox [(ng-model)]="data.CESP.chk_consent" id="consentCheckbox" (click)="showConsent($event)"
                         [title]="'ESR_main.consStatementCB_alt' | translate" [(ng-error)]="error_consent"
                              (focusout)="validate('consent')">
                  <span translate='ESR_main.consent_statement.text1'></span>    
                  <a [title]="'ESR_main.consent_statement.link_alt' | translate" (click)="showConsent($event)" translate
                        style="cursor: pointer;">
                        {{'ESR_main.consent_statement.link'}}</a>
                  <span translate='ESR_main.consent_statement.text2'></span>
            </ng-checkbox>
            
      </div>


     
     <h2 id="locate" class="title_margin"  html='ESR_main.locateOffice'></h2>
     
     <ng-input [(ng-model)]="data.CESP.postalCode" [(ng-error)]="error_postalCode" id="postalCodeInput"  (blur)="validate('pc')"                 
                  size="7" max="10" alt-text="ESR_main.postalCodeIn_alt">{{'ESR_main.postalCodeIn'}}</ng-input>
     
     <ng-input [(ng-model)]="data.CESP.country" [(ng-error)]="error_country" id="countryInput"  (blur)="validate('country')"                  
                  size="30" max="50" alt-text="ESR_main.countryIn_alt">{{'ESR_main.countryIn'}}</ng-input>
     
     <ng-radio [item-list]="items.contactMethodList" [(ng-model)] ="data.CESP.contactMethod" id="methodRadio"
                        [(ng-error)]="error_contactMethod" (change)="methodChanged()" (focusout)="validate('contact')" vertical>
                       <h2 id="method" class="title_margin"  html='ESR_main.contactMethod'></h2>
     </ng-radio>                        
     
     <ng-input [hidden]="data.CESP.contactMethod!=2" [(ng-model)]="data.CESP.contactEmail" id="emailInput" (blur)="validate('email')"  
            [(ng-error)]="error_email" size="30" max="80" 
            alt-text="ESR_main.emailIn_alt">{{'ESR_main.emailIn'}}</ng-input>           
      
     <div [hidden]="data.CESP.contactMethod!=1">
           <fieldset>

            <legend><div class="top-1" html='ESR_main.telephoneNumber'></div></legend>

            <div class="phone-div">
                  <div class="phone-label-area" translate>{{'ESR_main.areaCode'}}</div>
                  <div class="phone-label-local">
                        <span translate style="margin-right:0.4em">{{'ESR_main.local'}}</span>
                        <span translate>{{'ESR_main.number'}}</span>
                  </div>      
                  <div class="phone-label-ext" style="vertical-align: middle;" translate>{{'ESR_main.extension'}}</div>
            </div>
      
            
            <ng-input space="0.8" type="tel" outer-class="control-margin0" id="areaCodeInput"
                      [(ng-model)]="data.CESP.firstArea" 
                      [(ng-clear)]="error_phoneNumber" 
                      alt-text="ESR_main.areaCode_alt"
                      size="3" max="3"></ng-input>
            
            <ng-input space="0.3" type="tel" outer-class="control-margin0"
                      [(ng-model)]="data.CESP.firstNumber1" 
                      size="3" max="3" label-style="text-align:center" 
                      [(ng-clear)]="error_phoneNumber" 
                      alt-text="ESR_main.localNumber_alt1">
                      </ng-input>
            
            <span style="margin-right:0.3em">-</span>
            <ng-input space="0.8" type="tel" outer-class="control-margin0"
                      [(ng-model)]="data.CESP.firstNumber2" 
                      size="4" max="4" label-style="margin-left:0" 
                      [(ng-clear)]="error_phoneNumber" 
                      alt-text="ESR_main.localNumber_alt2">
                      </ng-input>
            
            <ng-input space="0" type="tel" outer-class="control-margin0"
                      [(ng-model)]="data.CESP.firstExt" 
                      [(ng-clear)]="error_phoneNumber"
                      size="4" max="6"
                      alt-text="ESR_main.extension_alt">
                      </ng-input>

            <div class="tty1">
                  <div style="position: absolute; top:-2.7em; font-size:0.94em" translate>{{'ESR_main.tty'}}</div>
                  <ng-checkbox [(ng-model)]="data.CESP.firstTTY" [title]="'ESR_main.tty_alt' | translate"
                        (focusout)="validate('phone')">
                        <span translate='ESR_main.tty' class="sr-only"></span>
                  </ng-checkbox> 
            </div>

             <div class="tty2">
                <ng-checkbox [(ng-model)]="data.CESP.firstTTY">{{'ESR_main.tty'}}</ng-checkbox> 
             </div>         

            </fieldset>        

            <errors [error]="error_phoneNumber"></errors>          
            
            
            <fieldset>         
            <legend><div class="top-15"  html='ESR_main.secondaryPhoneNumber'></div></legend>

            <div class="phone-div">
                  <div class="phone-label-area" translate>{{'ESR_main.areaCode'}}</div>
                  <div class="phone-label-local">
                        <span translate style="margin-right:0.4em">{{'ESR_main.local'}}</span>
                        <span translate>{{'ESR_main.number'}}</span>
                  </div>      
                  <div class="phone-label-ext" style="width:21%; vertical-align: middle;" translate>{{'ESR_main.extension'}}</div>
            </div>

            
            <ng-input space="0.8" type="tel" outer-class="control-margin0" id="areaCodeSecInput"
                      [(ng-model)]="data.CESP.secondArea" 
                      [(ng-clear)]="error_secondPhoneNumber" 
                      alt-text="ESR_main.areaCodeSec_alt"
                      size="3" max="3"></ng-input>
            
            <ng-input space="0.3" type="tel" outer-class="control-margin0"
                      [(ng-model)]="data.CESP.secondNumber1" 
                      size="3" max="3" label-style="text-align:center" 
                      [(ng-clear)]="error_secondPhoneNumber" 
                      alt-text="ESR_main.localNumberSec_alt1">
                      </ng-input>
            
            <span style="margin-right:0.3em">-</span>
            <ng-input space="0.8" type="tel" outer-class="control-margin0"
                      [(ng-model)]="data.CESP.secondNumber2" 
                      size="4" max="4" label-style="margin-left:0" 
                      [(ng-clear)]="error_secondPhoneNumber" 
                      alt-text="ESR_main.localNumberSec_alt2">
                      </ng-input>
            
            <ng-input space="0" type="tel" outer-class="control-margin0"
                      [(ng-model)]="data.CESP.secondExt" 
                      [(ng-clear)]="error_secondPhoneNumber"
                      size="4" max="6"
                      alt-text="ESR_main.extensionSec_alt">
                      </ng-input>
            
            <div class="tty1">
                  <div style="position: absolute; top:-2.7em; font-size:0.94em" translate>{{'ESR_main.tty'}}</div>
                  <ng-checkbox [(ng-model)]="data.CESP.secondTTY" [title]="'ESR_main.tty_alt' | translate"
                        (focusout)="validate('secondPhone')">
                        <span translate='ESR_main.tty' class="sr-only"></span>
                  </ng-checkbox> 
            </div>

             <div class="tty2">
                <ng-checkbox [(ng-model)]="data.CESP.secondTTY">{{'ESR_main.tty'}}</ng-checkbox> 
             </div>         
            </fieldset> 

            <errors [error]="error_secondPhoneNumber"></errors>
     </div>         
     
      <h2 id="when" class="title_margin" html='ESR_main.whenContact'></h2> <!-- contactTimeList -->
      
      <div style="margin-top:0.5em" class="font-size-1">
            <ng-checkbox value='1' [(ng-model)]="contactMorning" margin="0/0.2">   {{items.contactTimeList.get('1')}} </ng-checkbox>
            <ng-checkbox value='2' [(ng-model)]="contactAfternoon"> {{items.contactTimeList.get('2')}} </ng-checkbox>
      </div>
      
      <!--
      <div *ngFor="let contactTime of items.contactTimeList | keyvalue">
            <ng-checkbox (change)="selectTime($event, contactTime.key)" (ngModel)="contactTime.key" class="font-size-1">
                  <div>{{contactTime.value}}</div>
            </ng-checkbox> 
      </div>
      -->


     <ng-radio [item-list]="items.langList" [(ng-model)] ="data.CESP.contactLang" vertical (click)="deSelectLangRadio($event)" (keydown)="deSelectLangRadio($event)">
            <h2 id="lang" class="title_margin"  html='ESR_main.whatLang'></h2>
     </ng-radio>
     
     <h2 id="when" class="title_margin"  html='ESR_main.childInfo'></h2>
     
     <div [innerHTML]="'ESR_main.name'|translate : childNameParam"></div>     
     <div [innerHTML]="'ESR_main.dob'|translate : childPOBParam"></div>
     

     <!-- PRIVACY-->
      <div class="title_margin">
            <h2 id="privacy" html='ESR_main.privacyNotice.header'></h2>
            
            <ng-checkbox [(ng-model)]="data.CESP.chk_privacy" id="privacyCheckbox" (click)="showNotice($event)" 
                        [title]="'ESR_main.noticeCB_alt' | translate" [(ng-error)]="error_notice">
                  <span translate='ESR_main.privacyNotice.text1'></span>    
                  <a [title]="'ESR_main.privacyNotice.link_alt' | translate" (click)="showNotice($event)" translate>
                        {{'ESR_main.privacyNotice.link'}}</a>
                  <span translate='ESR_main.privacyNotice.text2'></span>
            </ng-checkbox>
      </div>
     
     
      <div style="margin-top: 0.2em;">
            <ng-checkbox [(ng-model)]="data.CESP.chk_disclosure" [(ng-error)]="error_disclosure" id="disclosureCheckbox" (click)="validateDisclosure($event)">
                  <span translate='ESR_main.herebyCB'></span>
            </ng-checkbox>
      </div>

      <div id="bottom" class="btn-div">
            <div class="button-top">
                  <button class="btn-next3" title="{{Button.Next_alt|translate}}" 
                        (click)="onNextClick()" translate>{{Button.Next}}</button></div>
            <div class="button-bottom">
                  <button class="btn-cancel-esr" title="{{'ESR_main.dontWantBT_alt'|translate}}" 
                        (click)="dontRequest()" translate>{{'ESR_main.dontWantBT'}}</button></div>
      </div>
     
      <div class="flex-center accord-body">
            <span></span>
            <accordion label="ESR_main.accordion_what_if.header" outer-class="accord-width33">
                  <span [innerHTML]="'ESR_main.accordion_what_if.content' | translate"></span>
            </accordion>
            <span></span>
     </div>
     <br>
     
</div>


<light-box input-class="white-box" #noticeBox outer-style="font-size:0.88em; margin-top:1em"> 
      <div style="margin-left: 0.9em; margin-right: 0.9em; padding-top: 0.4em;">
            <information outer-class="full">
                  <div class="info-title"> 
                  <strong><span html='ESR_main.pleaseSelect'></span></strong>
                  </div>
            </information>
      </div>

      <div class="notice-padding">
            <h3 translate class='header-lightbox'>
                  {{'ESR_main.accPrivacyNotice'}}
            </h3>
      </div>

      <div class="margin1">
            <span [innerHTML]="'ESR_main.expPrivacyNotice_1'|translate"></span>    
            <a-link link-url="ESR_main.infosource_link.link" 
                  alt-text="ESR_main.infosource_link.alt" 
                  label='ESR_main.infosource_link.label'></a-link>
            <span [innerHTML]="'ESR_main.expPrivacyNotice_1_1' |translate"></span>

            <a-link link-url="ESR_main.privacyLinkURL" 
                        alt-text="ESR_main.privacyLink_alt" 
                        label='ESR_main.privacyLink'></a-link>
            <span translate='ESR_main.expPrivacyNotice_2'></span>
      </div>

      <div style="margin-top: 1em 1em 1.8em 1em" style="float:right; cursor:pointer">
            <a tabindex="0" role="button" style="margin-right:1em"  
              (click)="notAgreeNoticeClose()" (keypress)="keyPress($event, 'notice')">
                  {{'ESR_main.closeBT' | translate}}
            </a>
      </div>  

      <div class="btn-div" style="margin-top: 3em;">   
            <button class="btn-next-notice" (click)="agreeNoticeClose()" alt-text="ESR_main.agreeBT_alt" translate>
                  {{'ESR_main.agreeBT'}}
            </button>   
      </div>                           
</light-box>


<light-box input-class="white-box" #consBox outer-style="font-size:0.88em; margin-top:1em">
      <div style="margin-left: 0.9em; margin-right: 0.9em; padding-top: 0.4em;">
            <information outer-class="full"> 
                  <div class="info-title"> 
                  <strong><span html='ESR_main.consent_lightbox.pleaseSelect'></span></strong>
                  </div>
            </information>
      </div>

      <div class="notice-padding">
            <h3 translate class='header-lightbox'>
                  {{'ESR_main.consent_statement.header'}}
            </h3>
      </div>
      
      <div class="margin1">
            <span [innerHTML]="'ESR_main.consent_lightbox.statement'|translate"></span>    
      </div>    
      <div style="margin-top: 1em 1em 1.8em 1em" style="float:right; cursor:pointer">
            <a tabindex="0" role="button" style="margin-right:1em"  
               (click)="notAgreeConsClose()" (keypress)="keyPress($event, 'consent')">
                 {{'ESR_main.closeBT' | translate}}
            </a>
      </div>  
      
      <div class="btn-div" style="margin-top: 3em;">   
            <button class="btn-next-notice" (click)="agreeConsClose()" 
                  alt-text="ESR_main.agreeConsBT_alt" translate>
                  {{'ESR_main.agreeBT'}}
            </button>  
      </div>
</light-box>

<light-box input-class="white-box" #discBox outer-style="font-size:0.88em; margin-top:1em">
      <div style="margin-left: 0.9em; margin-right: 0.9em; padding-top: 0.4em;">
            <information outer-class="full">
                  <div class="info-title"> 
                  <strong><span html='ESR_main.pleaseSelect'></span></strong>
                  </div>
            </information>
      </div>
      
      <div class="notice-padding">
            <h3 translate class='header-lightbox'>
                  {{'ESR_main.disclaimer.header'}}
            </h3>
      </div>
      <div class="margin1">
            <span [innerHTML]="'ESR_main.expDiscStatement_1'|translate"></span>    
            <a-link link-url="ESR_main.hereLinkURL" 
                        alt-text="ESR_main.hereLink_alt" 
                        label='ESR_main.hereLink'></a-link>
            <span [innerHTML]="'ESR_main.expDiscStatement_2'|translate"></span>
            <a-link link-url="ESR_main.gvCanadaLinkURL" 
                        alt-text="ESR_main.gvCanadaLink_alt" 
                        label='ESR_main.gvCanadaLink'></a-link>
            <span>.</span>
      </div>

      <div style="margin-top: 1em 1em 1.8em 1em" style="float:right; cursor:pointer">
            <a tabindex="0" role="button" style="margin-right:1em"  
               (click)="notAgreeDiscClose()" (keypress)="keyPress($event, 'disclaimer')" translate>
                 {{'ESR_main.closeBT'}}
            </a>
      </div>  
                  
      <div class="btn-div" style="margin-top: 3em;"> 
            <button class="btn-next-notice" (click)="agreeDiscClose()" 
                  alt-text="ESR_main.agreeDiscBT_alt" translate>{{'ESR_main.agreeBT'}}
            </button>    
      </div>                          
</light-box>
